__turbopack_context__.v({
  "gridContainer": "OutletListSkeleton-module-scss-module__braiKa__gridContainer",
  "groupHeaderSkeleton": "OutletListSkeleton-module-scss-module__braiKa__groupHeaderSkeleton",
  "searchInputSkeleton": "OutletListSkeleton-module-scss-module__braiKa__searchInputSkeleton",
  "wl": "OutletListSkeleton-module-scss-module__braiKa__wl",
});
